import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import UnderConstruction from '../../components/UnderConstruction';
import SharedHeader from '../../components/SharedHeader';
import DashboardFooter from '../../components/DashboardFooter';
import './chapter_flashcards.css';

function ChapterFlashcards() {
  const { stepId, chapterId } = useParams();
  const navigate = useNavigate();
  
  // # Handle return to flashcards
  const handleReturn = () => {
    const isAdmin = window.location.pathname.startsWith('/admin');
    navigate(isAdmin ? '/admin/flashcards' : '/flashcards');
  };
  
  return (
    <div className="flsh_chp_card_chapter_container">
      <SharedHeader />
      <div className="flsh_chp_card_chapter_main">
        <div className="flsh_chp_card_chapter_header">
          <button onClick={handleReturn} className="flsh_chp_card_return_button">
            ← Back to Flashcards
          </button>
          <h1>{`${stepId} ${chapterId} Flashcards`}</h1>
        </div>
        <UnderConstruction pageName={`${stepId} ${chapterId} Flashcards`} />
      </div>
      <DashboardFooter />
    </div>
  );
}

export default ChapterFlashcards; 